import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { firstValueFrom } from 'rxjs';

export const permissionGuard: CanActivateFn = async (route, state) => {
  // Use this way:
  // path: 'providers', 
  // component: ProvidersComponent, 
  // canActivate: [permissionGuard], 
  // data: { 
  //    permission: 'provider_read'
  // } 
  let permission = route.data['permission'];
  const auth = inject(AuthService);
  const router = inject(Router);
  if (await firstValueFrom(auth.hasWithLoad(permission))) {
    return true;
  }

  router.navigate(['/']);
  return false;
};
